// Global Instructions Rule Applied!
//
// `PUT /tasks/{id}` echoes only the fields that were sent (a completion
// toggle sends `tasks__id` + `tasks__completed`), so the response is a patch,
// not the task. Merge it over the task already in Redux so the fields the
// patch did not carry — the subject above all — survive until the next fetch.
import { TaskRecordFields } from '../../../state_manager/data_models/task_record.ts'

type TaskLike = Record<string, unknown>

/** Legacy key some older task payloads used instead of `tasks__subject`. */
const LEGACY_TITLE_KEY = 'tasks__title'

export function mergeTaskUpdate<T extends TaskLike>(existing: T | undefined, response: TaskLike): T & TaskLike {
  const merged: TaskLike = { ...(existing ?? {}), ...response }
  if (!merged[TaskRecordFields.tasks__subject] && merged[LEGACY_TITLE_KEY]) {
    merged[TaskRecordFields.tasks__subject] = merged[LEGACY_TITLE_KEY]
  }
  return merged as T & TaskLike
}

/**
 * The subject to show for a task: `tasks__subject`, else the legacy
 * `tasks__title` some older payloads carried, else the placeholder.
 */
export function taskDisplaySubject(task: TaskLike, fallback = 'Untitled Task'): string {
  const subject = task[TaskRecordFields.tasks__subject] || task[LEGACY_TITLE_KEY]
  return typeof subject === 'string' && subject ? subject : fallback
}
